import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AttendeeSquare from './attendee-square-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;
    const fill = validProps.fill || colors.offWhiteDk;

    return <AttendeeSquare {...validProps} fill={fill} />;
}

SvgComponent.iconName = 'attendeeSquare';

export const AttendeeSquareIcon = svgIconWrapper(SvgComponent);
